import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import ProfilePage from '..';
import useIsMobile from '../../../components/hooks/useIsMobile';
import { useAdDynamicConfig } from '../../../components/hooks/useAdDynamicConfig';
import { useStatsig } from '../../../components/hooks/useStatsig';
import { getCollegeCoachProfileViews } from '../../../actions/profile-actions';
import { getApiAxiosInstance } from '../../../utils/network';
import { saveProfileView } from '../../../api';

const PROFILE_VIEWS_PAGE_SIZE = 3;

function ProfilePageWrapper(props) {
    const user = useSelector((state) => state.auth?.user);
    const profileViews = useSelector((state) => state.profile?.profileViews || {});
    const profileViewsState = useSelector((state) => state.profile?.profileViewsState || {});
    const { initializeStatsigUser } = useStatsig();
    const { showAds, playerProfileConfig } = useAdDynamicConfig();
    const { isMobileWidth } = useIsMobile();
    const dispatch = useDispatch();
    const hasInitializedUser = useRef(false);
    const params = useParams();
    const playerId = parseInt(params?.playerId);
    const claimedPlayerId = user?.claimedPlayer?.playerId;
    const isCurrentUsersProfile = playerId === claimedPlayerId;

    const fetchCollegeCoachViews = async () => {
        await dispatch(getCollegeCoachProfileViews(playerId, 0, PROFILE_VIEWS_PAGE_SIZE));
    };

    const saveCollegeCoachView = async () => {
        const axiosInstance = getApiAxiosInstance();
        try {
            await saveProfileView(axiosInstance, playerId);
        } catch (err) {
            console.error('Error saving profile view', err);
        }
    };

    useEffect(() => {
        if (!playerId || !claimedPlayerId) {
            return;
        }

        const hasCollegeCoachViews = Object.keys(profileViews)?.length > 0;
        const shouldFetchViews = isCurrentUsersProfile && !hasCollegeCoachViews;

        if (shouldFetchViews) {
            fetchCollegeCoachViews();
        }
    }, []);

    useEffect(() => {
        if (user && !hasInitializedUser.current) {
            initializeStatsigUser();
            saveCollegeCoachView();
            hasInitializedUser.current = true;
        }
    }, [user, initializeStatsigUser]);

    useEffect(() => {
        const hasFetchedViews = profileViewsState?.complete;
        const hasLockedViews = profileViews?.views?.some((view) => view?.isLocked);
        const shouldRefetchViews = user?.isPowered && hasFetchedViews && isCurrentUsersProfile && hasLockedViews;

        if (shouldRefetchViews) {
            fetchCollegeCoachViews();
        }
    }, [user?.isPowered]);

    return (
        <ProfilePage
            showAds={showAds}
            isMobileWidth={isMobileWidth}
            playerProfileConfig={playerProfileConfig}
            {...props}
        />
    );
}

export default ProfilePageWrapper;
